/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Taxonomy_Use_Cases_Automation_TitleInputs */

const en_directory_taxonomy_use_cases_automation_title = /** @type {(inputs: Directory_Taxonomy_Use_Cases_Automation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automate work`)
};

const zh_directory_taxonomy_use_cases_automation_title = /** @type {(inputs: Directory_Taxonomy_Use_Cases_Automation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动化工作`)
};

/**
* | output |
* | --- |
* | "Automate work" |
*
* @param {Directory_Taxonomy_Use_Cases_Automation_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_taxonomy_use_cases_automation_title = /** @type {((inputs?: Directory_Taxonomy_Use_Cases_Automation_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Taxonomy_Use_Cases_Automation_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_taxonomy_use_cases_automation_title(inputs)
	return zh_directory_taxonomy_use_cases_automation_title(inputs)
});
export { directory_taxonomy_use_cases_automation_title as "directory.taxonomy.use-cases.automation.title" }